<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="pageTitle && pageTitle !== 'Login'"
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.href"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text" :to="item.href">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="pink"
      dark
      app
      fixed
      tabs
    >
      <v-toolbar-title v-if="pageTitle" style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon v-if="pageTitle !== 'Login'" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span>{{ pageTitle }}</span>
      </v-toolbar-title>
      <v-btn v-if="!pageTitle  && $route.name !== 'NoInternetConnection'" flat @click.native.stop="back()" class="ml-0">
            <v-icon left>arrow_back</v-icon>
        </v-btn>
      <v-spacer></v-spacer>
      <v-btn icon v-if="pageTitle && pageTitle === 'Vizite'" @click="onAction('filter')">
        <v-icon>filter_list</v-icon>
      </v-btn>
      <template v-if="!pageTitle && $route.name !== 'NoInternetConnection'">
          <v-btn icon @click="onAction('add')">
              <v-icon>add</v-icon>
          </v-btn>
          <v-menu offset-y>
            <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
            <v-list>
               <v-list-tile v-for="(item, index) in actions" :key="index" @click="onAction(item.id)">
                  <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
          </v-menu>
      </template>

      <v-tabs
        v-if="pageTitle && pageTitle === 'Vizite'"
        slot="extension"
        v-model="tab"
        color="pink"
        grow
      >
        <v-tabs-slider color="yellow"></v-tabs-slider>

        <v-tab
          v-for="item in $store.state.visits.tabItems"
          :key="item.id"
          :class="{ activeClass : item.id === tab }"
        >
          {{ item.text }}
        </v-tab>
      </v-tabs>

    </v-toolbar>
    <v-content>
      <v-container fluid grid-list-lg :fill-height="$store.state.centerViewVertical">
        <v-slide-x-transition mode="out-in">
          <router-view :key="$route.fullPath"></router-view>
        </v-slide-x-transition>
      </v-container>
    </v-content>
    <toast-message></toast-message>
    <confirmation-dialog></confirmation-dialog>
  </v-app>
</template>

<script>
  import bus from '../../bus';

  export default {
    data: () => ({
      drawer: null
    }),

    computed: {
      tab: {
        get() {
          return this.$store.state.visits.tab;
        },

        set(val) {
          this.$store.commit('visits/TAB', val);
        }
      },

      items: {
        get() {
          return [
            { icon: 'my_location', text: 'Vizite', href: '/' },
            { icon: 'history', text: 'Istoric Aparate', href: '/reports-machine-history' },
            { icon: 'check_circle_outline', text: 'Acțiuni de făcut', href: '/reports-actions' },
            { icon: 'settings', text: 'Setari', href: '/settings' }
          ];
        }
      },

      actions: {
        get() {
          return [
            { id: 'edit', text: 'Editează' }
          ];
        }
      },

      pageTitle() {
        return (
          this.$store.state.pageTitle || this.$router.currentRoute.meta.title
        );
      }
    },

    methods: {
      navigate(href) {
        this.$router.push({ path: href });
      },

      back() {
        this.$router.push({ path: this.$store.state.fromPage });
      },

      onAction(type) {
        switch (type) {
          case 'edit':
            let visit = { ...this.$store.state.visits.data.find(f => f.id === ~~this.$route.params.id) };
            delete visit.created_at;
            delete visit.updated_at;
            this.$store.commit('visits/DIALOG', visit);
            break;
          case 'delete':
            bus.$emit('confirmation-dialog-show', {
              title: 'Confirmare ștergere',
              text: `Sunteți sigur că doriți să ștergeți vizita?`,
              actionButton: 'Șterge',
              action: () => {
                this.$store
                  .dispatch('visits/DELETE', this.$route.params.id)
                  .then(() => {
                    bus.$emit('toast-message-show', {
                      text: `Vizita a fost ștearsă.`
                    });
                    this.$router.push({ path: '/' });
                  })
                  .catch(() => {
                    bus.$emit('toast-message-show', {
                      error: true,
                      text: `A intervenit o eroare la ștergerea vizitei.`
                    });
                  });
              }
            });
            break;
          case 'add':
            this.$store.commit('actions/FILTER', '');
            this.$store.commit('actions/SELECT', null);
            this.$store.commit('actions/DIALOG', { id: null, visit_id: ~~this.$route.params.id, status: 1 });
            break;
          case 'filter':
            this.$store.commit('visits/FILTER', true);
            break;
        };
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/layouts/Default.vue